'use strict';

//export const API_URL = 'http://localhost:50027/api/'; // Local
//export const API_URL = 'http://172.16.1.112:3008/api/'; // Pruebas
export const API_URL = 'https://valeraemocional.alcanosesp.com/api/'; // Producción 
